import React from 'react';
import { useParams } from 'react-router-dom';

export default function BookDetail() {
    const { id } = useParams();

    return (
        <div className="min-h-screen bg-white text-black flex items-center justify-center p-12">
            <div className="text-center space-y-4">
                <h1 className="text-3xl font-bold">Book ID: {id}</h1>
                <p>This is a placeholder page for the selected book.</p>
            </div>
        </div>
    );
}
